module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "expo"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": "",
      "maxlength": 3,
      "placeholder": "請輸入桌號",
      "icon": "circle-close",
      "on-icon-click": _vm.clear,
      "size": "large",
      "type": "number",
      "pattern": "[0-9]*",
      "inputmode": "numeric"
    },
    model: {
      value: (_vm.table),
      callback: function($$v) {
        _vm.table = $$v
      },
      expression: "table"
    }
  }), _vm._v(" "), (_vm.matchedPosts.length === 0) ? _c('h1', [_c('span', [_vm._v(_vm._s((_vm.table === '' ? '請輸入桌號' : '找不到專案')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchedPosts), function(post) {
    return [_c('el-card', {
      staticClass: "box-card",
      attrs: {
        "body-style": "height:inherit;padding:0px"
      }
    }, [_c('postsummary', {
      attrs: {
        "title": post.name,
        "subtitle": (post.author || '').split('@')[0] + ' @ ' + post.table + '桌',
        "description": ("(" + (post.table) + "桌) " + (post.desc)),
        "table": Number(post.table),
        "postKey": post['.key'],
        "authorId": post.uid,
        "starCount": post.starCount,
        "stars": post.stars,
        "heartCount": post.heartCount,
        "hearts": post.hearts,
        "tags": post.tags,
        "host": post.host
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b8d24c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Expo.vue
// module id = 964
// module chunks = 1